/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const Register = {
	$domRegisterBtn: $('.js-profile-reg-btn'),
	isFetching: false,

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
		this.initCompanyDropdown();
	},

	/**
	 * @description Bind events
	 */
	bindEvents: function() {
		this.$domRegisterBtn.on('click', this.registerForm);
		$('#company-not-found').on('change', this.toggleCompanyFields);
	},

	/**
	 * @description Initialize searchable company dropdown
	 */
	initCompanyDropdown: function() {
		const $companySelect = $('#reg-field-name-comp');
		$companySelect.select2({
			placeholder: 'Odaberite kompaniju...',
			allowClear: true,
		});
	},

	/**
	 * @description Toggle company fields based on checkbox state
	 */
	toggleCompanyFields: function() {
		const $companySelect = $('#reg-field-name-comp');
		const $suggestCompanyField = $('#suggest-company-field');
		const $suggestCompanyInput = $('#suggested-company');

		if ($(this).is(':checked')) {
			$companySelect.val(null).trigger('change').prop('disabled', true);
			$companySelect.next('.select2-container').hide();
			$suggestCompanyField.show();
			$suggestCompanyInput.prop('required', true);
		} else {
			$companySelect.prop('disabled', false);
			$companySelect.next('.select2-container').show();
			$suggestCompanyField.hide();
			$suggestCompanyInput.prop('required', false);
		}
	},

	/**
	 * @description Handles user registration
	 */
	registerForm: async function(event) {
		event.preventDefault();

		if (Register.isFetching) {
			return;
		}

		// Identify the active tab/form
		const $activeForm = $(this).closest('form');
		const isCompanyForm = $activeForm.attr('id') === 'tab-2';

		// Collect data and perform validation
		const email = $activeForm.find('input[type="email"]').val().trim();
		const password = $activeForm.find('input[type="password"]').eq(0).val().trim();
		const repeatPassword = $activeForm.find('input[type="password"]').eq(1).val().trim();
		const termsChecked = $activeForm.find('input[type="checkbox"]').is(':checked');

		let companyName = null;
		let suggestedCompany = null;

		if (isCompanyForm) {
			const $companyNotFound = $('#company-not-found');
			const $companySelect = $('#reg-field-name-comp');
			const $suggestedCompanyInput = $('#suggested-company');

			if ($companyNotFound.is(':checked')) {
				suggestedCompany = $suggestedCompanyInput.val().trim();
				companyName = null;
			} else {
				companyName = $companySelect.val();
			}
		}

		// Clear previous error messages
		$activeForm.find('.form-error').remove();

		let isValid = true;

		// Validation
		if (!email) {
			Register.showError($activeForm, 'Email is obavezan.');
			isValid = false;
		}

		if (!password || password.length < 8) {
			Register.showError($activeForm, 'Lozinka mora da ima najmanje 8 znakova.');
			isValid = false;
		}

		if (password !== repeatPassword) {
			Register.showError($activeForm, 'Lozinke se ne poklapaju.');
			isValid = false;
		}

		if (!termsChecked) {
			Register.showError($activeForm, 'Morate prihvatiti uslove korišćenja.');
			isValid = false;
		}

		if (isCompanyForm) {
			if (!companyName && !suggestedCompany) {
				Register.showError($activeForm, 'Potrebno je izabrati kompaniju ili je predložiti.');
				isValid = false;
			}
		}

		if (!isValid) {
			return;
		}

		// Prepare data for API request
		const requestData = {
			email,
			password,
			company: companyName,
			suggested_company: suggestedCompany,
		};

		Register.isFetching = true;

		try {
			const response = await fetch('/wp-json/office-pulse-api/v1/auth/register', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestData),
			});

			const result = await response.json();

			if (response.ok) {
				Register.showSuccess($activeForm, 'Registracija uspešna. Redirektovanje...');
				setTimeout(() => {
					window.location.href = result.redirect_url || '/';
				}, 2000);
			} else {
				Register.showError($activeForm, result.error || 'Registracija neuspešna. Pokušajte kasnije.');
			}
		} catch (error) {
			Register.showError($activeForm, 'An unexpected error occurred. Please try again.');
			console.error('Error:', error);
		} finally {
			Register.isFetching = false;
		}
	},

	/**
	 * @description Display error message
	 * @param {jQuery} $form - Form element
	 * @param {string} message - Error message
	 */
	showError: function($form, message) {
		const $errorDiv = $('<div>')
			.addClass('form-message form-error')
			.text(message);

		$form.find('.form-error').remove();
		$form.prepend($errorDiv);
	},

	/**
	 * @description Display success message
	 * @param {jQuery} $form - Form element
	 * @param {string} message - Success message
	 */
	showSuccess: function($form, message) {
		const $successDiv = $('<div>')
			.addClass('form-message form-success')
			.text(message);

		$form.find('.form-success').remove();
		$form.prepend($successDiv);
	},
};

export default Register;
